/* DO NOT EDIT! This file is auto-generated by graphql-code-generator - see `codegen.yaml` */
/* eslint-disable @typescript-eslint/ban-types,no-duplicate-imports */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { DocumentNode } from 'graphql'
import gql from 'graphql-tag'
export type UserFieldsFragment = (
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'emailConfirmed' | 'mobile' | 'mobileConfirmed' | 'gender' | 'marketingPreferences' | 'userPreferences' | 'createdAt' | 'promoCodeIds'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
);

export type AddressFieldsFragment = Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'county' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId' | 'parkingInformationId' | 'createdAt'>;

export type CardFieldsFragment = Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason' | 'createdAt'>;

export type TreatmentFieldsFragment = (
  Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'type' | 'isPackage' | 'isOption' | 'isTreatment' | 'tags'>
  & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>>, optionGroups?: Maybe<Array<Maybe<(
    Pick<TreatmentOptionGroup, 'name' | 'multiSelect' | 'defaultIndex'>
    & { options?: Maybe<Array<Maybe<(
      Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'selected'>
      & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>> }
    )>>> }
  )>>> }
);

export type BookingFieldsFragment = (
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
);

export type ChatFieldsFragment = (
  Pick<Chat, '_id' | 'professionalId' | 'clientId'>
  & { professional?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, client?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, lastMessage: Pick<LastMessage, 'message' | 'sentAt'>, messageCount: { professional: Pick<MessageCount, 'unreadMessages' | 'sent'>, client: Pick<MessageCount, 'unreadMessages' | 'sent'> } }
);

export type FavouriteFieldsFragment = (
  Pick<Favourite, '_id' | 'userId'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'profileUrl'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'treatmentIds' | 'postcodeIds' | 'averageReview' | 'reviewCount' | 'favouriteCount'>> }
  )> }
);

export type TreatmentStubFieldsFragment = (
  Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'price' | 'fee' | 'tags' | 'type' | 'duration' | 'numberOfPros'>
  & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>> }
);

export type AdjustmentFieldsFragment = Pick<Adjustment, '_id' | 'bookingId' | 'professionalId' | 'note' | 'amount' | 'adjustmentType' | 'payoutDrafted' | 'createdAt'>;

export type ProfessionalProfileFieldsFragment = (
  Pick<ProfessionalProfile, 'averageReview' | 'reviewCount' | 'favouriteCount' | 'bio' | 'information' | 'disabledOptionIds' | 'genderPreference' | 'numberOfBookings' | 'lastBookedAt' | 'teamNote'>
  & { treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name' | 'type'>>>>, postcodes?: Maybe<Array<Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>>>> }
);

export type ProfileMatchFieldsFragment = (
  Pick<ProfileMatch, 'userId' | 'favouriteCount' | 'reviewCount' | 'averageReview'>
  & { user?: Maybe<Pick<UserDetails, '_id' | 'firstName' | 'lastName' | 'profileUrl'>> }
);

export type SuggestedProfessionalFragment = (
  Pick<ProfileMatch, '_id' | 'userId' | 'featured' | 'favouriteCount' | 'reviewCount' | 'isFavourite' | 'numberOfBookings' | 'averageReview' | 'disabledOptionIds'>
  & { user?: Maybe<Pick<UserDetails, '_id' | 'firstName' | 'lastName' | 'profileUrl'>>, treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>>, availability?: Maybe<Array<Maybe<Pick<ProfessionalAvailability, 'day'>>>> }
);

export type AvailableProfessionalsFieldsFragment = (
  Pick<AvailableProfessionals, 'day'>
  & { professionals?: Maybe<Array<Maybe<(
    Pick<InstantProfessional, 'day' | 'availableTimeSlots' | 'bookedTimesSlots' | 'bookingId'>
    & { professional?: Maybe<(
      Pick<Professional, '_id' | 'firstName' | 'lastName' | 'tags'>
      & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'featured' | 'information' | 'genderPreference' | 'numberOfBookings'>> }
    )> }
  )>>> }
);

export type UserPromoCodeFieldsFragment = (
  Pick<UserPromoCode, '_id' | 'promoCode' | 'expiryDate' | 'active' | 'discountType' | 'value' | 'featured' | 'expired' | 'canUse'>
  & { redeemAction?: Maybe<(
    Pick<RedeemAction, 'action'>
    & { givenByUser?: Maybe<Pick<User, 'firstName'>> }
  )>, limits?: Maybe<(
    Pick<PromoLimits, 'excludedTreatmentTypes' | 'includedTreatmentTypes'>
    & { excludedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>>, includedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>> }
  )>, reasons?: Maybe<Array<Maybe<Pick<PromoCodeErrorReasons, 'reason' | 'value'>>>> }
);

export type InAppMessageFieldsFragment = Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'updatedAt'>;

export type IdentifyWithMobileQueryVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
}>;

export type IdentifyWithMobileQuery = { identifyWithMobile?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>> }> };

export type CreateGuestUserMutationVariables = Exact<{ [key: string]: never; }>;

export type CreateGuestUserMutation = { createGuestUser?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>>, user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'emailConfirmed' | 'mobile' | 'mobileConfirmed' | 'gender' | 'marketingPreferences' | 'userPreferences' | 'createdAt' | 'promoCodeIds'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> }> };

export type LogoutMutationVariables = Exact<{
  uniqueDeviceId?: InputMaybe<Scalars['String']>;
}>;

export type LogoutMutation = Pick<Mutation, 'logout'>;

export type GetUserTraitsQueryVariables = Exact<{ [key: string]: never; }>;

export type GetUserTraitsQuery = Pick<Query, 'getUserTraits'>;

export type UserQueryVariables = Exact<{ [key: string]: never; }>;

export type UserQuery = { user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'emailConfirmed' | 'mobile' | 'mobileConfirmed' | 'gender' | 'marketingPreferences' | 'userPreferences' | 'createdAt' | 'promoCodeIds'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> };

export type TrackCampaignMutationVariables = Exact<{
  campaignData?: InputMaybe<Scalars['JSONObject']>;
}>;

export type TrackCampaignMutation = Pick<Mutation, 'trackCampaign'>;

export type SendMobileVerificationQueryVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
  silent?: InputMaybe<Scalars['Boolean']>;
}>;

export type SendMobileVerificationQuery = { sendMobileVerification?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>> }> };

export type CreateNewUserWithMobileMutationVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
  guestId?: InputMaybe<Scalars['String']>;
}>;

export type CreateNewUserWithMobileMutation = { createNewUserWithMobile?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>> }> };

export type VerifyMobileAndSignInMutationVariables = Exact<{
  mobile?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
}>;

export type VerifyMobileAndSignInMutation = { verifyMobileAndSignIn?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>>, user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'emailConfirmed' | 'mobile' | 'mobileConfirmed' | 'gender' | 'marketingPreferences' | 'userPreferences' | 'createdAt' | 'promoCodeIds'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> }> };

export type VerifyMobileAndCompleteAccountMutationVariables = Exact<{
  mobile: Scalars['String'];
  code: Scalars['String'];
  userData: RegistrationDetails;
}>;

export type VerifyMobileAndCompleteAccountMutation = { verifyMobileAndCompleteAccount?: Maybe<{ authToken?: Maybe<Pick<AuthToken, 'role' | 'auth'>>, user?: Maybe<(
  Pick<User, '_id' | 'firstName' | 'lastName' | 'emailAddress' | 'emailConfirmed' | 'mobile' | 'mobileConfirmed' | 'gender' | 'marketingPreferences' | 'userPreferences' | 'createdAt' | 'promoCodeIds'>
  & { subscriptionDetails?: Maybe<Pick<SubscriptionDetails, 'status'>> }
)> }> };

export type CategoriesQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  region?: InputMaybe<Scalars['String']>;
}>;

export type CategoriesQuery = { categories?: Maybe<Array<Maybe<(
  Pick<Category, '_id' | 'name' | 'treatmentIds' | 'slug' | 'description' | 'active'>
  & { images?: Maybe<Array<Maybe<Pick<CategoryImage, 'image' | 'text'>>>> }
)>>> };

export type GetTreatmentsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  postcodeId?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<TreatmentExtraInput>;
}>;

export type GetTreatmentsQuery = { getTreatments?: Maybe<Array<Maybe<(
  Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'price' | 'fee' | 'tags' | 'type' | 'duration' | 'numberOfPros'>
  & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>> }
)>>> };

export type GetTreatmentQueryVariables = Exact<{
  _id: Scalars['String'];
  getOptions?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  extra?: InputMaybe<TreatmentExtraInput>;
}>;

export type GetTreatmentQuery = { getTreatment?: Maybe<(
  Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'type' | 'isPackage' | 'isOption' | 'isTreatment' | 'tags'>
  & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>>, optionGroups?: Maybe<Array<Maybe<(
    Pick<TreatmentOptionGroup, 'name' | 'multiSelect' | 'defaultIndex'>
    & { options?: Maybe<Array<Maybe<(
      Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'selected'>
      & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>> }
    )>>> }
  )>>> }
)> };

export type RebookTreatmentsQueryVariables = Exact<{
  _id: Scalars['String'];
  extra?: InputMaybe<TreatmentExtraInput>;
}>;

export type RebookTreatmentsQuery = { rebookTreatments?: Maybe<Array<Maybe<(
  Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'type' | 'isPackage' | 'isOption' | 'isTreatment' | 'tags'>
  & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>>, optionGroups?: Maybe<Array<Maybe<(
    Pick<TreatmentOptionGroup, 'name' | 'multiSelect' | 'defaultIndex'>
    & { options?: Maybe<Array<Maybe<(
      Pick<Treatment, '_id' | 'name' | 'shortDescription' | 'duration' | 'price' | 'fee' | 'selected'>
      & { info?: Maybe<Array<Maybe<Pick<TreatmentInfo, 'title' | 'body'>>>> }
    )>>> }
  )>>> }
)>>> };

export type FindInstantProfessionalsQueryVariables = Exact<{
  matchingParams?: InputMaybe<InstantMatchingParams>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  proProfileFilter?: InputMaybe<Scalars['JSONObject']>;
  bookingId?: InputMaybe<Scalars['String']>;
}>;

export type FindInstantProfessionalsQuery = { findInstantProfessionals?: Maybe<Array<Maybe<(
  Pick<AvailableProfessionals, 'day'>
  & { professionals?: Maybe<Array<Maybe<(
    Pick<InstantProfessional, 'day' | 'availableTimeSlots' | 'bookedTimesSlots' | 'bookingId'>
    & { professional?: Maybe<(
      Pick<Professional, '_id' | 'firstName' | 'lastName' | 'tags'>
      & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'favouriteCount' | 'reviewCount' | 'averageReview' | 'featured' | 'information' | 'genderPreference' | 'numberOfBookings'>> }
    )> }
  )>>> }
)>>> };

export type FindSuggestedProfessionalsQueryVariables = Exact<{
  matchingParams?: InputMaybe<SuggestedMatchingParams>;
}>;

export type FindSuggestedProfessionalsQuery = { findSuggestedProfessionals?: Maybe<Array<Maybe<(
  Pick<ProfileMatch, '_id' | 'userId' | 'featured' | 'favouriteCount' | 'reviewCount' | 'isFavourite' | 'numberOfBookings' | 'averageReview' | 'disabledOptionIds'>
  & { user?: Maybe<Pick<UserDetails, '_id' | 'firstName' | 'lastName' | 'profileUrl'>>, treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name'>>>>, availability?: Maybe<Array<Maybe<Pick<ProfessionalAvailability, 'day'>>>> }
)>>> };

export type SelectProfessionalForRequestMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  professionalId?: InputMaybe<Scalars['String']>;
  date?: InputMaybe<Scalars['Date']>;
}>;

export type SelectProfessionalForRequestMutation = { selectProfessionalForRequest?: Maybe<(
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
)> };

export type EstimatedProfessionalAvailabilityQueryVariables = Exact<{
  matchingParams?: InputMaybe<InstantMatchingParams>;
  days?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  professionalIds?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
}>;

export type EstimatedProfessionalAvailabilityQuery = { estimatedProfessionalAvailability?: Maybe<Array<Maybe<Pick<EstimatedProfessionalAvailability, 'professionalId' | 'day' | 'availabilityStatus' | 'availableHours'>>>> };

export type SaveDraftBookingMutationVariables = Exact<{
  data?: InputMaybe<BookingInput>;
}>;

export type SaveDraftBookingMutation = { saveDraftBooking?: Maybe<(
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
)> };

export type PublishBookingMutationVariables = Exact<{
  data?: InputMaybe<BookingInput>;
  sendNotifications?: InputMaybe<Scalars['Boolean']>;
}>;

export type PublishBookingMutation = { publishBooking?: Maybe<(
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
)> };

export type AddPromoCodeToUserMutationVariables = Exact<{
  data: AddPromoCodeInput;
}>;

export type AddPromoCodeToUserMutation = { addPromoCodeToUser?: Maybe<(
  Pick<PromoCodeAdded, 'canApply' | 'promoCodeDiscount'>
  & { reasons?: Maybe<Array<Maybe<Pick<PromoCodeErrorReasons, 'reason' | 'value'>>>>, data?: Maybe<(
    Pick<UserPromoCode, '_id' | 'promoCode' | 'expiryDate' | 'active' | 'discountType' | 'value' | 'featured' | 'expired' | 'canUse'>
    & { redeemAction?: Maybe<(
      Pick<RedeemAction, 'action'>
      & { givenByUser?: Maybe<Pick<User, 'firstName'>> }
    )>, limits?: Maybe<(
      Pick<PromoLimits, 'excludedTreatmentTypes' | 'includedTreatmentTypes'>
      & { excludedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>>, includedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>> }
    )>, reasons?: Maybe<Array<Maybe<Pick<PromoCodeErrorReasons, 'reason' | 'value'>>>> }
  )> }
)> };

export type UserPromoCodesQueryVariables = Exact<{
  filter?: InputMaybe<UserPromoCodeInput>;
}>;

export type UserPromoCodesQuery = { userPromoCodes?: Maybe<Array<Maybe<(
  Pick<UserPromoCode, '_id' | 'promoCode' | 'expiryDate' | 'active' | 'discountType' | 'value' | 'featured' | 'expired' | 'canUse'>
  & { redeemAction?: Maybe<(
    Pick<RedeemAction, 'action'>
    & { givenByUser?: Maybe<Pick<User, 'firstName'>> }
  )>, limits?: Maybe<(
    Pick<PromoLimits, 'excludedTreatmentTypes' | 'includedTreatmentTypes'>
    & { excludedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>>, includedTreatments?: Maybe<Array<Maybe<Pick<Treatment, 'name'>>>> }
  )>, reasons?: Maybe<Array<Maybe<Pick<PromoCodeErrorReasons, 'reason' | 'value'>>>> }
)>>> };

export type GetCrossSellPromoCodeMutationVariables = Exact<{
  bookingId: Scalars['String'];
}>;

export type GetCrossSellPromoCodeMutation = { getCrossSellPromoCode?: Maybe<(
  Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'expiryDate'>
  & { limits?: Maybe<Pick<PromoLimits, 'excludedTreatmentTypes'>>, redeemAction?: Maybe<Pick<RedeemAction, 'receiveAmount'>> }
)> };

export type BookingQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type BookingQuery = { booking?: Maybe<(
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
)> };

export type BookingsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  sort?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
}>;

export type BookingsQuery = { bookings?: Maybe<Array<Maybe<(
  Pick<Booking, '_id' | 'createdAt' | 'status' | 'address' | 'totalPrice' | 'totalDuration' | 'totalFee' | 'items' | 'title' | 'date' | 'note' | 'reviewPrompted' | 'clientReviewId' | 'promoCodeDiscount' | 'postcodeId' | 'type' | 'region' | 'additionalInformation' | 'clientNote' | 'clientPictures' | 'totalLoyaltyPoints' | 'publishedDate' | 'tags' | 'crossSellPromoCode'>
  & { clientDetails?: Maybe<Array<Maybe<Pick<ClientDetails, 'contactNumber' | 'firstName' | 'gender'>>>>, clientReview?: Maybe<Pick<Review, 'comment' | 'rating'>>, requestedProfessionals?: Maybe<Array<Maybe<Pick<Professional, '_id' | 'firstName' | 'lastName'>>>>, requestedProfessionalResponses?: Maybe<Array<Maybe<Pick<RequestedProfessionalResponse, 'professionalId' | 'status' | 'respondedAt' | 'availabilityAdded'>>>>, professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'role' | 'gender'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'averageReview' | 'reviewCount'>> }
  )>, transactions?: Maybe<Array<Maybe<Pick<Transaction, '_id' | 'sourceType' | 'amount'>>>>, adjustments?: Maybe<Array<Maybe<Pick<Adjustment, '_id' | 'amount' | 'payoutDrafted' | 'professionalId' | 'adjustmentType' | 'note'>>>>, promoCode?: Maybe<(
    Pick<PromoCode, '_id' | 'promoCode' | 'value' | 'discountType'>
    & { limits?: Maybe<Pick<PromoLimits, 'includedTreatmentIds' | 'excludedTreatmentIds'>> }
  )>, postcode?: Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>> }
)>>> };

export type RequestBookingCancellationMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type RequestBookingCancellationMutation = Pick<Mutation, 'requestBookingCancellation'>;

export type CancelBookingMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type CancelBookingMutation = Pick<Mutation, 'cancelBooking'>;

export type CreateReviewMutationVariables = Exact<{
  data?: InputMaybe<NewReview>;
}>;

export type CreateReviewMutation = Pick<Mutation, 'createReview'>;

export type UpdateReviewPromptedMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  reviewPrompted?: InputMaybe<Scalars['Boolean']>;
}>;

export type UpdateReviewPromptedMutation = Pick<Mutation, 'updateReviewPrompted'>;

export type GetProfessionalQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  profileUrl?: InputMaybe<Scalars['String']>;
}>;

export type GetProfessionalQuery = { getProfessional?: Maybe<(
  Pick<Professional, '_id' | 'firstName' | 'lastName' | 'tags' | 'profileUrl'>
  & { professionalProfile?: Maybe<(
    Pick<ProfessionalProfile, 'averageReview' | 'reviewCount' | 'favouriteCount' | 'bio' | 'information' | 'disabledOptionIds' | 'genderPreference' | 'numberOfBookings' | 'lastBookedAt' | 'teamNote'>
    & { treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name' | 'type'>>>>, postcodes?: Maybe<Array<Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>>>> }
  )> }
)> };

export type SearchProfessionalsQueryVariables = Exact<{
  search?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
}>;

export type SearchProfessionalsQuery = { searchProfessionals?: Maybe<Array<Maybe<(
  Pick<Professional, '_id' | 'firstName' | 'lastName' | 'profileUrl'>
  & { professionalProfile?: Maybe<(
    Pick<ProfessionalProfile, 'averageReview' | 'reviewCount' | 'favouriteCount' | 'bio' | 'information' | 'disabledOptionIds' | 'genderPreference' | 'numberOfBookings' | 'lastBookedAt' | 'teamNote'>
    & { treatments?: Maybe<Array<Maybe<Pick<Treatment, '_id' | 'name' | 'type'>>>>, postcodes?: Maybe<Array<Maybe<Pick<Postcode, '_id' | 'code' | 'name' | 'region'>>>> }
  )> }
)>>> };

export type ReviewsQueryVariables = Exact<{
  filter?: InputMaybe<Scalars['JSONObject']>;
  pagination?: InputMaybe<Pagination>;
}>;

export type ReviewsQuery = { reviews?: Maybe<Array<Maybe<(
  Pick<Review, '_id' | 'professionalId' | 'comment' | 'createdAt' | 'rating' | 'pinned'>
  & { user?: Maybe<Pick<User, 'firstName' | 'lastName' | '_id'>> }
)>>> };

export type FavouritesQueryVariables = Exact<{ [key: string]: never; }>;

export type FavouritesQuery = { favourites?: Maybe<Array<Maybe<(
  Pick<Favourite, '_id' | 'userId'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'profileUrl'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'treatmentIds' | 'postcodeIds' | 'averageReview' | 'reviewCount' | 'favouriteCount'>> }
  )> }
)>>> };

export type AddFavouriteMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
}>;

export type AddFavouriteMutation = { addFavourite?: Maybe<(
  Pick<Favourite, '_id' | 'userId'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'profileUrl'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'treatmentIds' | 'postcodeIds' | 'averageReview' | 'reviewCount' | 'favouriteCount'>> }
  )> }
)> };

export type RemoveFavouriteMutationVariables = Exact<{
  professionalId?: InputMaybe<Scalars['String']>;
}>;

export type RemoveFavouriteMutation = { removeFavourite?: Maybe<(
  Pick<Favourite, '_id' | 'userId'>
  & { professional?: Maybe<(
    Pick<Professional, '_id' | 'firstName' | 'lastName' | 'profileUrl'>
    & { professionalProfile?: Maybe<Pick<ProfessionalProfile, 'treatmentIds' | 'postcodeIds' | 'averageReview' | 'reviewCount' | 'favouriteCount'>> }
  )> }
)> };

export type GetAddressesQueryVariables = Exact<{ [key: string]: never; }>;

export type GetAddressesQuery = { questions?: Maybe<{ address?: Maybe<Array<Maybe<Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'county' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId' | 'parkingInformationId' | 'createdAt'>>>> }> };

export type RemoveAddressMutationVariables = Exact<{
  addressId?: InputMaybe<Scalars['String']>;
}>;

export type RemoveAddressMutation = Pick<Mutation, 'removeAddress'>;

export type CheckPostcodeInServiceAreaQueryVariables = Exact<{
  postcode?: InputMaybe<Scalars['String']>;
}>;

export type CheckPostcodeInServiceAreaQuery = { checkPostcodeInServiceArea?: Maybe<Pick<Postcode, '_id' | 'code' | 'region' | 'name'>> };

export type AddOrUpdateAddressMutationVariables = Exact<{
  address?: InputMaybe<UserAddressInput>;
}>;

export type AddOrUpdateAddressMutation = { addOrUpdateAddress?: Maybe<Pick<UserAddress, '_id' | 'label' | 'firstLine' | 'secondLine' | 'city' | 'county' | 'postalCode' | 'note' | 'setDefaultAt' | 'userId' | 'parkingInformationId' | 'createdAt'>> };

export type GetParkingInformationQueryVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  addressId?: InputMaybe<Scalars['String']>;
}>;

export type GetParkingInformationQuery = { getParkingInformation?: Maybe<Pick<ParkingInformation, '_id' | 'locationDetails' | 'locationType' | 'cost' | 'note' | 'postcode' | 'addressId'>> };

export type AddorUpdateParkingInformationMutationVariables = Exact<{
  data: ParkingInformationInput;
}>;

export type AddorUpdateParkingInformationMutation = { addorUpdateParkingInformation?: Maybe<Pick<ParkingInformation, '_id' | 'locationDetails' | 'locationType' | 'cost' | 'note' | 'postcode' | 'addressId'>> };

export type AnswersMutationVariables = Exact<{
  answers: QuestionAnswer;
}>;

export type AnswersMutation = { answers?: Maybe<Pick<AnsweredQuestions, 'profile'>> };

export type BalanceQueryVariables = Exact<{
  order?: InputMaybe<OrderDetails>;
}>;

export type BalanceQuery = Pick<Query, 'balance'>;

export type RequestCardSetupIntentQueryVariables = Exact<{ [key: string]: never; }>;

export type RequestCardSetupIntentQuery = Pick<Query, 'requestCardSetupIntent'>;

export type CardsQueryVariables = Exact<{
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type CardsQuery = { cards?: Maybe<Array<Maybe<Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason' | 'createdAt'>>>> };

export type AddCardMutationVariables = Exact<{
  token?: InputMaybe<CardToken>;
  admin?: InputMaybe<Scalars['JSONObject']>;
}>;

export type AddCardMutation = { addCard?: Maybe<Pick<Card, '_id' | 'setDefaultAt' | 'userId' | 'stripePaymentMethod' | 'expMonth' | 'expYear' | 'lastFourDigits' | 'brand' | 'blocked' | 'blockedReason' | 'createdAt'>> };

export type UpdateDefaultCardMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
  setDefaultAt?: InputMaybe<Scalars['String']>;
}>;

export type UpdateDefaultCardMutation = { updateDefaultCard?: Maybe<Pick<Card, '_id'>> };

export type RemoveCardMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type RemoveCardMutation = { removeCard?: Maybe<Pick<Card, '_id'>> };

export type CompletePaymentMutationVariables = Exact<{
  order: Order;
}>;

export type CompletePaymentMutation = { completePayment?: Maybe<Pick<PaymentCompleteResponse, 'isPaid'>> };

export type CreateGiftCardMutationVariables = Exact<{
  data?: InputMaybe<GiftCardInput>;
}>;

export type CreateGiftCardMutation = { createGiftCard?: Maybe<Pick<GiftCard, '_id' | 'type' | 'recipientEmail' | 'fromEmail' | 'recipientName' | 'fromName' | 'recipientAddress' | 'note' | 'sentTo' | 'amount' | 'code'>> };

export type ValidateGiftCardMutationVariables = Exact<{
  _id?: InputMaybe<Scalars['String']>;
}>;

export type ValidateGiftCardMutation = { validateGiftCard?: Maybe<Pick<GiftCard, '_id'>> };

export type RedeemGiftCardMutationVariables = Exact<{
  giftCardCode?: InputMaybe<Scalars['String']>;
}>;

export type RedeemGiftCardMutation = { redeemGiftCard?: Maybe<Pick<GiftCard, 'amount'>> };

export type TipProfessionalMutationVariables = Exact<{
  data?: InputMaybe<TipInput>;
}>;

export type TipProfessionalMutation = { tipProfessional?: Maybe<{ adjustment?: Maybe<Pick<Adjustment, '_id' | 'bookingId' | 'professionalId' | 'note' | 'amount' | 'adjustmentType' | 'payoutDrafted' | 'createdAt'>> }> };

export type LoyaltyPointsQueryVariables = Exact<{ [key: string]: never; }>;

export type LoyaltyPointsQuery = { loyaltyPoints?: Maybe<(
  Pick<LoyaltyRewardPoints, 'availablePoints' | 'lifetimePoints'>
  & { history?: Maybe<Array<Maybe<Pick<LoyaltyReward, '_id' | 'userId' | 'bookingId' | 'points' | 'type' | 'convertedValue' | 'createdAt'>>>> }
)> };

export type RedeemRewardMutationVariables = Exact<{
  pointsToRedeem: Scalars['Int'];
}>;

export type RedeemRewardMutation = { redeemReward?: Maybe<{ redeemedReward?: Maybe<Pick<LoyaltyReward, '_id' | 'userId' | 'bookingId' | 'points' | 'type' | 'convertedValue' | 'createdAt'>>, transaction?: Maybe<Pick<Transaction, '_id'>> }> };

export type CalculateLoyaltyPointsQueryVariables = Exact<{
  data?: InputMaybe<CalculateLoyaltyPointsInput>;
}>;

export type CalculateLoyaltyPointsQuery = Pick<Query, 'calculateLoyaltyPoints'>;

export type IsApiUpQueryVariables = Exact<{ [key: string]: never; }>;

export type IsApiUpQuery = Pick<Query, 'isApiUp'>;

export type SettingsQueryVariables = Exact<{ [key: string]: never; }>;

export type SettingsQuery = { settings?: Maybe<Pick<Setting, '_id' | 'platform' | 'settings'>> };

export type AppVerQueryVariables = Exact<{ [key: string]: never; }>;

export type AppVerQuery = { appVer?: Maybe<Pick<AppVersion, 'apiVersion' | 'minConsumerAppVer' | 'minProAppVer'>> };

export type ChatsQueryVariables = Exact<{ [key: string]: never; }>;

export type ChatsQuery = { chats: Array<Maybe<(
  Pick<Chat, '_id' | 'professionalId' | 'clientId'>
  & { professional?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, client?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, lastMessage: Pick<LastMessage, 'message' | 'sentAt'>, messageCount: { professional: Pick<MessageCount, 'unreadMessages' | 'sent'>, client: Pick<MessageCount, 'unreadMessages' | 'sent'> } }
)>> };

export type MarkChatAsReadMutationVariables = Exact<{
  conversationId: Scalars['String'];
}>;

export type MarkChatAsReadMutation = Pick<Mutation, 'markChatAsRead'>;

export type FindOrCreateChatMutationVariables = Exact<{
  professionalId: Scalars['String'];
}>;

export type FindOrCreateChatMutation = { findOrCreateChat: (
  Pick<Chat, '_id' | 'professionalId' | 'clientId'>
  & { professional?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, client?: Maybe<Pick<ChatUser, 'firstName' | 'lastName'>>, lastMessage: Pick<LastMessage, 'message' | 'sentAt'>, messageCount: { professional: Pick<MessageCount, 'unreadMessages' | 'sent'>, client: Pick<MessageCount, 'unreadMessages' | 'sent'> } }
) };

export type GetUnreadMessagesQueryVariables = Exact<{ [key: string]: never; }>;

export type GetUnreadMessagesQuery = Pick<Query, 'getUnreadMessages'>;

export type CheckBlockedUserQueryVariables = Exact<{ [key: string]: never; }>;

export type CheckBlockedUserQuery = Pick<Query, 'checkBlockedUser'>;

export type GetConfigQueryVariables = Exact<{ [key: string]: never; }>;

export type GetConfigQuery = (
  Pick<Query, 'checkBlockedUser'>
  & { appVer?: Maybe<Pick<AppVersion, 'apiVersion' | 'minConsumerAppVer' | 'minProAppVer'>>, settings?: Maybe<Pick<Setting, '_id' | 'platform' | 'settings'>> }
);

export type PageQueryVariables = Exact<{
  type?: InputMaybe<Scalars['String']>;
}>;

export type PageQuery = { page?: Maybe<Pick<Page, '_id' | 'title' | 'body' | 'type'>> };

export type CreateOrUpdateDeviceMutationVariables = Exact<{
  data?: InputMaybe<UserDeviceInput>;
}>;

export type CreateOrUpdateDeviceMutation = { createOrUpdateDevice?: Maybe<Pick<UserDevice, 'uniqueDeviceId' | 'apnsToken' | 'fcmToken' | 'device' | 'platform' | 'platformVersion' | 'notificationsPermissionStatus' | 'notificationAccessRequested' | 'deviceRegisteredForNotifications' | 'appVersion'>> };

export type UploadFileMutationVariables = Exact<{
  file: Scalars['Upload'];
  path?: InputMaybe<Scalars['String']>;
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;

export type UploadFileMutation = Pick<Mutation, 'uploadFile'>;

export type DeleteFileMutationVariables = Exact<{
  filename?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Scalars['String']>;
}>;

export type DeleteFileMutation = Pick<Mutation, 'deleteFile'>;

export type TriggerUserEventQueryVariables = Exact<{
  data: UserEventInput;
}>;

export type TriggerUserEventQuery = Pick<Query, 'triggerUserEvent'>;

export type CheckProfessionalAvailabilityQueryVariables = Exact<{
  matchingParams: InstantMatchingParams;
  professionalId: Scalars['String'];
  bookingId?: InputMaybe<Scalars['String']>;
  date: Scalars['Date'];
}>;

export type CheckProfessionalAvailabilityQuery = Pick<Query, 'checkProfessionalAvailability'>;

export type ManageSubscriptionUrlQueryVariables = Exact<{ [key: string]: never; }>;

export type ManageSubscriptionUrlQuery = Pick<Query, 'manageSubscriptionUrl'>;

export type CheckoutUrlQueryVariables = Exact<{
  checkoutData: CheckoutInfo;
}>;

export type CheckoutUrlQuery = Pick<Query, 'checkoutUrl'>;

export type DeleteUserMutationVariables = Exact<{ [key: string]: never; }>;

export type DeleteUserMutation = Pick<Mutation, 'deleteUser'>;

export type InAppMessagesQueryVariables = Exact<{
  filter: InAppMessageFilter;
}>;

export type InAppMessagesQuery = { inAppMessages: Array<Pick<InAppMessage, '_id' | 'name' | 'platform' | 'eventName' | 'match' | 'contentType' | 'updatedAt'>> };

export type InAppMessageQueryVariables = Exact<{
  _id: Scalars['String'];
}>;

export type InAppMessageQuery = { inAppMessage?: Maybe<Pick<InAppMessage, 'name' | 'content'>> };

export type PrepareForPaymentQueryVariables = Exact<{
  orderInfo: OrderInfo;
}>;

export type PrepareForPaymentQuery = { prepareForPayment: Pick<PreparePaymentResponse, 'clientSecret' | 'paymentIntentId'> };

export const UserFieldsFragmentDoc = gql`
    fragment UserFields on User {
  _id
  firstName
  lastName
  emailAddress
  emailConfirmed
  mobile
  mobileConfirmed
  gender
  marketingPreferences
  userPreferences
  createdAt
  promoCodeIds
  subscriptionDetails {
    status
  }
}
    `
export const AddressFieldsFragmentDoc = gql`
    fragment AddressFields on UserAddress {
  _id
  label
  firstLine
  secondLine
  city
  county
  postalCode
  note
  setDefaultAt
  userId
  parkingInformationId
  createdAt
}
    `
export const CardFieldsFragmentDoc = gql`
    fragment CardFields on Card {
  _id
  setDefaultAt
  userId
  stripePaymentMethod
  expMonth
  expYear
  lastFourDigits
  brand
  blocked
  blockedReason
  createdAt
}
    `
export const TreatmentFieldsFragmentDoc = gql`
    fragment TreatmentFields on Treatment {
  _id
  name
  shortDescription
  duration
  price
  fee
  type
  isPackage
  isOption
  isTreatment
  info {
    title
    body
  }
  optionGroups {
    name
    multiSelect
    defaultIndex
    options {
      _id
      name
      shortDescription
      duration
      price
      fee
      selected
      info {
        title
        body
      }
    }
  }
  tags
}
    `
export const BookingFieldsFragmentDoc = gql`
    fragment BookingFields on Booking {
  _id
  createdAt
  status
  address
  totalPrice
  totalDuration
  totalFee
  items
  title
  date
  note
  reviewPrompted
  clientReviewId
  clientDetails {
    contactNumber
    firstName
    gender
  }
  clientReview {
    comment
    rating
  }
  requestedProfessionals {
    _id
    firstName
    lastName
  }
  requestedProfessionalResponses {
    professionalId
    status
    respondedAt
    availabilityAdded
  }
  professional {
    _id
    firstName
    lastName
    role
    gender
    professionalProfile {
      averageReview
      reviewCount
    }
  }
  transactions {
    _id
    sourceType
    amount
  }
  adjustments {
    _id
    amount
    payoutDrafted
    professionalId
    adjustmentType
    note
  }
  promoCodeDiscount
  promoCode {
    _id
    promoCode
    value
    discountType
    limits {
      includedTreatmentIds
      excludedTreatmentIds
    }
  }
  postcodeId
  postcode {
    _id
    code
    name
    region
  }
  type
  region
  additionalInformation
  clientNote
  clientPictures
  totalLoyaltyPoints
  publishedDate
  tags
  crossSellPromoCode
}
    `
export const ChatFieldsFragmentDoc = gql`
    fragment ChatFields on Chat {
  _id
  professionalId
  professional {
    firstName
    lastName
  }
  clientId
  client {
    firstName
    lastName
  }
  lastMessage {
    message
    sentAt
  }
  messageCount {
    professional {
      unreadMessages
      sent
    }
    client {
      unreadMessages
      sent
    }
  }
}
    `
export const FavouriteFieldsFragmentDoc = gql`
    fragment FavouriteFields on Favourite {
  _id
  userId
  professional {
    _id
    firstName
    lastName
    profileUrl
    professionalProfile {
      treatmentIds
      postcodeIds
      averageReview
      reviewCount
      favouriteCount
    }
  }
}
    `
export const TreatmentStubFieldsFragmentDoc = gql`
    fragment TreatmentStubFields on Treatment {
  _id
  name
  shortDescription
  price
  fee
  tags
  type
  duration
  numberOfPros
  info {
    title
    body
  }
}
    `
export const AdjustmentFieldsFragmentDoc = gql`
    fragment AdjustmentFields on Adjustment {
  _id
  bookingId
  professionalId
  note
  amount
  adjustmentType
  payoutDrafted
  createdAt
}
    `
export const ProfessionalProfileFieldsFragmentDoc = gql`
    fragment ProfessionalProfileFields on ProfessionalProfile {
  averageReview
  reviewCount
  treatments {
    _id
    name
    type
  }
  favouriteCount
  bio
  postcodes {
    _id
    code
    name
    region
  }
  information
  disabledOptionIds
  genderPreference
  numberOfBookings
  lastBookedAt
  teamNote
}
    `
export const ProfileMatchFieldsFragmentDoc = gql`
    fragment ProfileMatchFields on ProfileMatch {
  userId
  user {
    _id
    firstName
    lastName
    profileUrl
  }
  favouriteCount
  reviewCount
  averageReview
}
    `
export const SuggestedProfessionalFragmentDoc = gql`
    fragment SuggestedProfessional on ProfileMatch {
  _id
  userId
  user {
    _id
    firstName
    lastName
    profileUrl
  }
  featured
  favouriteCount
  reviewCount
  isFavourite
  numberOfBookings
  averageReview
  treatments {
    _id
    name
  }
  availability {
    day
  }
  disabledOptionIds
}
    `
export const AvailableProfessionalsFieldsFragmentDoc = gql`
    fragment AvailableProfessionalsFields on AvailableProfessionals {
  day
  professionals {
    professional {
      _id
      firstName
      lastName
      tags
      professionalProfile {
        favouriteCount
        reviewCount
        averageReview
        featured
        information
        genderPreference
        numberOfBookings
      }
    }
    day
    availableTimeSlots
    bookedTimesSlots
    bookingId
  }
}
    `
export const UserPromoCodeFieldsFragmentDoc = gql`
    fragment UserPromoCodeFields on UserPromoCode {
  _id
  promoCode
  expiryDate
  active
  discountType
  value
  redeemAction {
    action
    givenByUser {
      firstName
    }
  }
  limits {
    excludedTreatments {
      name
    }
    includedTreatments {
      name
    }
    excludedTreatmentTypes
    includedTreatmentTypes
  }
  featured
  expired
  canUse
  reasons {
    reason
    value
  }
}
    `
export const InAppMessageFieldsFragmentDoc = gql`
    fragment InAppMessageFields on InAppMessage {
  _id
  name
  platform
  eventName
  match
  contentType
  updatedAt
}
    `
export const IdentifyWithMobileDocument = gql`
    query identifyWithMobile($mobile: String) {
  identifyWithMobile(mobile: $mobile) {
    authToken {
      role
      auth
    }
  }
}
    `
export const CreateGuestUserDocument = gql`
    mutation createGuestUser {
  createGuestUser {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`
export const LogoutDocument = gql`
    mutation logout($uniqueDeviceId: String) {
  logout(uniqueDeviceId: $uniqueDeviceId)
}
    `
export const GetUserTraitsDocument = gql`
    query getUserTraits {
  getUserTraits
}
    `
export const UserDocument = gql`
    query user {
  user {
    ...UserFields
  }
}
    ${UserFieldsFragmentDoc}`
export const TrackCampaignDocument = gql`
    mutation trackCampaign($campaignData: JSONObject) {
  trackCampaign(campaignData: $campaignData)
}
    `
export const SendMobileVerificationDocument = gql`
    query sendMobileVerification($mobile: String, $silent: Boolean) {
  sendMobileVerification(mobile: $mobile, silent: $silent) {
    authToken {
      role
      auth
    }
  }
}
    `
export const CreateNewUserWithMobileDocument = gql`
    mutation createNewUserWithMobile($mobile: String, $guestId: String) {
  createNewUserWithMobile(mobile: $mobile, guestId: $guestId) {
    authToken {
      role
      auth
    }
  }
}
    `
export const VerifyMobileAndSignInDocument = gql`
    mutation verifyMobileAndSignIn($mobile: String, $code: String) {
  verifyMobileAndSignIn(mobile: $mobile, code: $code) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`
export const VerifyMobileAndCompleteAccountDocument = gql`
    mutation verifyMobileAndCompleteAccount($mobile: String!, $code: String!, $userData: RegistrationDetails!) {
  verifyMobileAndCompleteAccount(
    mobile: $mobile
    code: $code
    userData: $userData
  ) {
    authToken {
      role
      auth
    }
    user {
      ...UserFields
    }
  }
}
    ${UserFieldsFragmentDoc}`
export const CategoriesDocument = gql`
    query categories($filter: JSONObject, $region: String) {
  categories(filter: $filter, region: $region) {
    _id
    name
    treatmentIds
    slug
    description
    active
    images {
      image
      text
    }
  }
}
    `
export const GetTreatmentsDocument = gql`
    query getTreatments($filter: JSONObject, $postcodeId: String, $extra: TreatmentExtraInput) {
  getTreatments(filter: $filter, postcodeId: $postcodeId, extra: $extra) {
    ...TreatmentStubFields
  }
}
    ${TreatmentStubFieldsFragmentDoc}`
export const GetTreatmentDocument = gql`
    query getTreatment($_id: String!, $getOptions: Boolean, $region: String, $extra: TreatmentExtraInput) {
  getTreatment(_id: $_id, getOptions: $getOptions, region: $region, extra: $extra) {
    ...TreatmentFields
  }
}
    ${TreatmentFieldsFragmentDoc}`
export const RebookTreatmentsDocument = gql`
    query rebookTreatments($_id: String!, $extra: TreatmentExtraInput) {
  rebookTreatments(_id: $_id, extra: $extra) {
    ...TreatmentFields
  }
}
    ${TreatmentFieldsFragmentDoc}`
export const FindInstantProfessionalsDocument = gql`
    query findInstantProfessionals($matchingParams: InstantMatchingParams, $days: [String], $proProfileFilter: JSONObject, $bookingId: String) {
  findInstantProfessionals(
    matchingParams: $matchingParams
    days: $days
    proProfileFilter: $proProfileFilter
    bookingId: $bookingId
  ) {
    ...AvailableProfessionalsFields
  }
}
    ${AvailableProfessionalsFieldsFragmentDoc}`
export const FindSuggestedProfessionalsDocument = gql`
    query findSuggestedProfessionals($matchingParams: SuggestedMatchingParams) {
  findSuggestedProfessionals(matchingParams: $matchingParams) {
    ...SuggestedProfessional
  }
}
    ${SuggestedProfessionalFragmentDoc}`
export const SelectProfessionalForRequestDocument = gql`
    mutation selectProfessionalForRequest($_id: String, $professionalId: String, $date: Date) {
  selectProfessionalForRequest(
    _id: $_id
    professionalId: $professionalId
    date: $date
  ) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const EstimatedProfessionalAvailabilityDocument = gql`
    query estimatedProfessionalAvailability($matchingParams: InstantMatchingParams, $days: [String], $professionalIds: [String]) {
  estimatedProfessionalAvailability(
    matchingParams: $matchingParams
    days: $days
    professionalIds: $professionalIds
  ) {
    professionalId
    day
    availabilityStatus
    availableHours
  }
}
    `
export const SaveDraftBookingDocument = gql`
    mutation saveDraftBooking($data: BookingInput) {
  saveDraftBooking(data: $data) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const PublishBookingDocument = gql`
    mutation publishBooking($data: BookingInput, $sendNotifications: Boolean) {
  publishBooking(data: $data, sendNotifications: $sendNotifications) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const AddPromoCodeToUserDocument = gql`
    mutation addPromoCodeToUser($data: AddPromoCodeInput!) {
  addPromoCodeToUser(data: $data) {
    canApply
    promoCodeDiscount
    reasons {
      reason
      value
    }
    data {
      ...UserPromoCodeFields
    }
  }
}
    ${UserPromoCodeFieldsFragmentDoc}`
export const UserPromoCodesDocument = gql`
    query userPromoCodes($filter: UserPromoCodeInput) {
  userPromoCodes(filter: $filter) {
    ...UserPromoCodeFields
  }
}
    ${UserPromoCodeFieldsFragmentDoc}`
export const GetCrossSellPromoCodeDocument = gql`
    mutation getCrossSellPromoCode($bookingId: String!) {
  getCrossSellPromoCode(bookingId: $bookingId) {
    _id
    promoCode
    value
    limits {
      excludedTreatmentTypes
    }
    redeemAction {
      receiveAmount
    }
    expiryDate
  }
}
    `
export const BookingDocument = gql`
    query booking($_id: String) {
  booking(_id: $_id) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const BookingsDocument = gql`
    query bookings($filter: JSONObject, $sort: JSONObject, $pagination: Pagination) {
  bookings(filter: $filter, sort: $sort, pagination: $pagination) {
    ...BookingFields
  }
}
    ${BookingFieldsFragmentDoc}`
export const RequestBookingCancellationDocument = gql`
    mutation requestBookingCancellation($_id: String) {
  requestBookingCancellation(_id: $_id)
}
    `
export const CancelBookingDocument = gql`
    mutation cancelBooking($_id: String) {
  cancelBooking(_id: $_id)
}
    `
export const CreateReviewDocument = gql`
    mutation createReview($data: NewReview) {
  createReview(data: $data)
}
    `
export const UpdateReviewPromptedDocument = gql`
    mutation updateReviewPrompted($_id: String, $reviewPrompted: Boolean) {
  updateReviewPrompted(_id: $_id, reviewPrompted: $reviewPrompted)
}
    `
export const GetProfessionalDocument = gql`
    query getProfessional($_id: String, $profileUrl: String) {
  getProfessional(_id: $_id, profileUrl: $profileUrl) {
    _id
    firstName
    lastName
    tags
    profileUrl
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
}
    ${ProfessionalProfileFieldsFragmentDoc}`
export const SearchProfessionalsDocument = gql`
    query searchProfessionals($search: String, $region: String) {
  searchProfessionals(search: $search, region: $region) {
    _id
    firstName
    lastName
    profileUrl
    professionalProfile {
      ...ProfessionalProfileFields
    }
  }
}
    ${ProfessionalProfileFieldsFragmentDoc}`
export const ReviewsDocument = gql`
    query reviews($filter: JSONObject, $pagination: Pagination) {
  reviews(filter: $filter, pagination: $pagination) {
    _id
    professionalId
    user {
      firstName
      lastName
      _id
    }
    comment
    createdAt
    rating
    pinned
  }
}
    `
export const FavouritesDocument = gql`
    query favourites {
  favourites {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const AddFavouriteDocument = gql`
    mutation addFavourite($professionalId: String) {
  addFavourite(professionalId: $professionalId) {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const RemoveFavouriteDocument = gql`
    mutation removeFavourite($professionalId: String) {
  removeFavourite(professionalId: $professionalId) {
    ...FavouriteFields
  }
}
    ${FavouriteFieldsFragmentDoc}`
export const GetAddressesDocument = gql`
    query getAddresses {
  questions {
    address {
      ...AddressFields
    }
  }
}
    ${AddressFieldsFragmentDoc}`
export const RemoveAddressDocument = gql`
    mutation removeAddress($addressId: String) {
  removeAddress(addressId: $addressId)
}
    `
export const CheckPostcodeInServiceAreaDocument = gql`
    query checkPostcodeInServiceArea($postcode: String) {
  checkPostcodeInServiceArea(postcode: $postcode) {
    _id
    code
    region
    name
  }
}
    `
export const AddOrUpdateAddressDocument = gql`
    mutation addOrUpdateAddress($address: UserAddressInput) {
  addOrUpdateAddress(address: $address) {
    ...AddressFields
  }
}
    ${AddressFieldsFragmentDoc}`
export const GetParkingInformationDocument = gql`
    query getParkingInformation($_id: String, $addressId: String) {
  getParkingInformation(_id: $_id, addressId: $addressId) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
  }
}
    `
export const AddorUpdateParkingInformationDocument = gql`
    mutation addorUpdateParkingInformation($data: ParkingInformationInput!) {
  addorUpdateParkingInformation(data: $data) {
    _id
    locationDetails
    locationType
    cost
    note
    postcode
    addressId
  }
}
    `
export const AnswersDocument = gql`
    mutation answers($answers: QuestionAnswer!) {
  answers(answers: $answers) {
    profile
  }
}
    `
export const BalanceDocument = gql`
    query balance($order: OrderDetails) {
  balance(order: $order)
}
    `
export const RequestCardSetupIntentDocument = gql`
    query requestCardSetupIntent {
  requestCardSetupIntent
}
    `
export const CardsDocument = gql`
    query cards($admin: JSONObject) {
  cards(admin: $admin) {
    ...CardFields
  }
}
    ${CardFieldsFragmentDoc}`
export const AddCardDocument = gql`
    mutation addCard($token: CardToken, $admin: JSONObject) {
  addCard(token: $token, admin: $admin) {
    ...CardFields
  }
}
    ${CardFieldsFragmentDoc}`
export const UpdateDefaultCardDocument = gql`
    mutation updateDefaultCard($_id: String, $setDefaultAt: String) {
  updateDefaultCard(_id: $_id, setDefaultAt: $setDefaultAt) {
    _id
  }
}
    `
export const RemoveCardDocument = gql`
    mutation removeCard($_id: String) {
  removeCard(_id: $_id) {
    _id
  }
}
    `
export const CompletePaymentDocument = gql`
    mutation completePayment($order: Order!) {
  completePayment(order: $order) {
    isPaid
  }
}
    `
export const CreateGiftCardDocument = gql`
    mutation createGiftCard($data: GiftCardInput) {
  createGiftCard(data: $data) {
    _id
    type
    recipientEmail
    fromEmail
    recipientName
    fromName
    recipientAddress
    note
    sentTo
    amount
    code
  }
}
    `
export const ValidateGiftCardDocument = gql`
    mutation validateGiftCard($_id: String) {
  validateGiftCard(_id: $_id) {
    _id
  }
}
    `
export const RedeemGiftCardDocument = gql`
    mutation redeemGiftCard($giftCardCode: String) {
  redeemGiftCard(giftCardCode: $giftCardCode) {
    amount
  }
}
    `
export const TipProfessionalDocument = gql`
    mutation tipProfessional($data: TipInput) {
  tipProfessional(data: $data) {
    adjustment {
      ...AdjustmentFields
    }
  }
}
    ${AdjustmentFieldsFragmentDoc}`
export const LoyaltyPointsDocument = gql`
    query loyaltyPoints {
  loyaltyPoints {
    availablePoints
    lifetimePoints
    history {
      _id
      userId
      bookingId
      points
      type
      convertedValue
      createdAt
    }
  }
}
    `
export const RedeemRewardDocument = gql`
    mutation redeemReward($pointsToRedeem: Int!) {
  redeemReward(pointsToRedeem: $pointsToRedeem) {
    redeemedReward {
      _id
      userId
      bookingId
      points
      type
      convertedValue
      createdAt
    }
    transaction {
      _id
    }
  }
}
    `
export const CalculateLoyaltyPointsDocument = gql`
    query calculateLoyaltyPoints($data: CalculateLoyaltyPointsInput) {
  calculateLoyaltyPoints(data: $data)
}
    `
export const IsApiUpDocument = gql`
    query isApiUp {
  isApiUp
}
    `
export const SettingsDocument = gql`
    query settings {
  settings {
    _id
    platform
    settings
  }
}
    `
export const AppVerDocument = gql`
    query appVer {
  appVer {
    apiVersion
    minConsumerAppVer
    minProAppVer
  }
}
    `
export const ChatsDocument = gql`
    query chats {
  chats {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`
export const MarkChatAsReadDocument = gql`
    mutation markChatAsRead($conversationId: String!) {
  markChatAsRead(conversationId: $conversationId)
}
    `
export const FindOrCreateChatDocument = gql`
    mutation findOrCreateChat($professionalId: String!) {
  findOrCreateChat(professionalId: $professionalId) {
    ...ChatFields
  }
}
    ${ChatFieldsFragmentDoc}`
export const GetUnreadMessagesDocument = gql`
    query getUnreadMessages {
  getUnreadMessages
}
    `
export const CheckBlockedUserDocument = gql`
    query checkBlockedUser {
  checkBlockedUser
}
    `
export const GetConfigDocument = gql`
    query getConfig {
  checkBlockedUser
  appVer {
    apiVersion
    minConsumerAppVer
    minProAppVer
  }
  settings {
    _id
    platform
    settings
  }
}
    `
export const PageDocument = gql`
    query page($type: String) {
  page(type: $type) {
    _id
    title
    body
    type
  }
}
    `
export const CreateOrUpdateDeviceDocument = gql`
    mutation createOrUpdateDevice($data: UserDeviceInput) {
  createOrUpdateDevice(data: $data) {
    uniqueDeviceId
    apnsToken
    fcmToken
    device
    platform
    platformVersion
    notificationsPermissionStatus
    notificationAccessRequested
    deviceRegisteredForNotifications
    appVersion
  }
}
    `
export const UploadFileDocument = gql`
    mutation uploadFile($file: Upload!, $path: String, $filename: String, $type: String) {
  uploadFile(file: $file, path: $path, filename: $filename, type: $type)
}
    `
export const DeleteFileDocument = gql`
    mutation deleteFile($filename: String, $type: String) {
  deleteFile(filename: $filename, type: $type)
}
    `
export const TriggerUserEventDocument = gql`
    query triggerUserEvent($data: UserEventInput!) {
  triggerUserEvent(data: $data)
}
    `
export const CheckProfessionalAvailabilityDocument = gql`
    query checkProfessionalAvailability($matchingParams: InstantMatchingParams!, $professionalId: String!, $bookingId: String, $date: Date!) {
  checkProfessionalAvailability(
    matchingParams: $matchingParams
    professionalId: $professionalId
    bookingId: $bookingId
    date: $date
  )
}
    `
export const ManageSubscriptionUrlDocument = gql`
    query manageSubscriptionUrl {
  manageSubscriptionUrl
}
    `
export const CheckoutUrlDocument = gql`
    query checkoutUrl($checkoutData: CheckoutInfo!) {
  checkoutUrl(checkoutData: $checkoutData)
}
    `
export const DeleteUserDocument = gql`
    mutation deleteUser {
  deleteUser
}
    `
export const InAppMessagesDocument = gql`
    query inAppMessages($filter: InAppMessageFilter!) {
  inAppMessages(filter: $filter) {
    ...InAppMessageFields
  }
}
    ${InAppMessageFieldsFragmentDoc}`
export const InAppMessageDocument = gql`
    query inAppMessage($_id: String!) {
  inAppMessage(_id: $_id) {
    name
    content
  }
}
    `
export const PrepareForPaymentDocument = gql`
    query prepareForPayment($orderInfo: OrderInfo!) {
  prepareForPayment(orderInfo: $orderInfo) {
    clientSecret
    paymentIntentId
  }
}
    `
export type Requester<C = {}, E = unknown> = <R, V>(doc: DocumentNode, vars?: V, options?: C) => Promise<R> | AsyncIterable<R>
export function getSdk<C, E>(requester: Requester<C, E>) {
  return {
    identifyWithMobile(variables?: IdentifyWithMobileQueryVariables, options?: C): Promise<IdentifyWithMobileQuery> {
      return requester<IdentifyWithMobileQuery, IdentifyWithMobileQueryVariables>(IdentifyWithMobileDocument, variables, options) as Promise<IdentifyWithMobileQuery>
    },
    createGuestUser(variables?: CreateGuestUserMutationVariables, options?: C): Promise<CreateGuestUserMutation> {
      return requester<CreateGuestUserMutation, CreateGuestUserMutationVariables>(CreateGuestUserDocument, variables, options) as Promise<CreateGuestUserMutation>
    },
    logout(variables?: LogoutMutationVariables, options?: C): Promise<LogoutMutation> {
      return requester<LogoutMutation, LogoutMutationVariables>(LogoutDocument, variables, options) as Promise<LogoutMutation>
    },
    getUserTraits(variables?: GetUserTraitsQueryVariables, options?: C): Promise<GetUserTraitsQuery> {
      return requester<GetUserTraitsQuery, GetUserTraitsQueryVariables>(GetUserTraitsDocument, variables, options) as Promise<GetUserTraitsQuery>
    },
    user(variables?: UserQueryVariables, options?: C): Promise<UserQuery> {
      return requester<UserQuery, UserQueryVariables>(UserDocument, variables, options) as Promise<UserQuery>
    },
    trackCampaign(variables?: TrackCampaignMutationVariables, options?: C): Promise<TrackCampaignMutation> {
      return requester<TrackCampaignMutation, TrackCampaignMutationVariables>(TrackCampaignDocument, variables, options) as Promise<TrackCampaignMutation>
    },
    sendMobileVerification(variables?: SendMobileVerificationQueryVariables, options?: C): Promise<SendMobileVerificationQuery> {
      return requester<SendMobileVerificationQuery, SendMobileVerificationQueryVariables>(SendMobileVerificationDocument, variables, options) as Promise<SendMobileVerificationQuery>
    },
    createNewUserWithMobile(variables?: CreateNewUserWithMobileMutationVariables, options?: C): Promise<CreateNewUserWithMobileMutation> {
      return requester<CreateNewUserWithMobileMutation, CreateNewUserWithMobileMutationVariables>(CreateNewUserWithMobileDocument, variables, options) as Promise<CreateNewUserWithMobileMutation>
    },
    verifyMobileAndSignIn(variables?: VerifyMobileAndSignInMutationVariables, options?: C): Promise<VerifyMobileAndSignInMutation> {
      return requester<VerifyMobileAndSignInMutation, VerifyMobileAndSignInMutationVariables>(VerifyMobileAndSignInDocument, variables, options) as Promise<VerifyMobileAndSignInMutation>
    },
    verifyMobileAndCompleteAccount(variables: VerifyMobileAndCompleteAccountMutationVariables, options?: C): Promise<VerifyMobileAndCompleteAccountMutation> {
      return requester<VerifyMobileAndCompleteAccountMutation, VerifyMobileAndCompleteAccountMutationVariables>(VerifyMobileAndCompleteAccountDocument, variables, options) as Promise<VerifyMobileAndCompleteAccountMutation>
    },
    categories(variables?: CategoriesQueryVariables, options?: C): Promise<CategoriesQuery> {
      return requester<CategoriesQuery, CategoriesQueryVariables>(CategoriesDocument, variables, options) as Promise<CategoriesQuery>
    },
    getTreatments(variables?: GetTreatmentsQueryVariables, options?: C): Promise<GetTreatmentsQuery> {
      return requester<GetTreatmentsQuery, GetTreatmentsQueryVariables>(GetTreatmentsDocument, variables, options) as Promise<GetTreatmentsQuery>
    },
    getTreatment(variables: GetTreatmentQueryVariables, options?: C): Promise<GetTreatmentQuery> {
      return requester<GetTreatmentQuery, GetTreatmentQueryVariables>(GetTreatmentDocument, variables, options) as Promise<GetTreatmentQuery>
    },
    rebookTreatments(variables: RebookTreatmentsQueryVariables, options?: C): Promise<RebookTreatmentsQuery> {
      return requester<RebookTreatmentsQuery, RebookTreatmentsQueryVariables>(RebookTreatmentsDocument, variables, options) as Promise<RebookTreatmentsQuery>
    },
    findInstantProfessionals(variables?: FindInstantProfessionalsQueryVariables, options?: C): Promise<FindInstantProfessionalsQuery> {
      return requester<FindInstantProfessionalsQuery, FindInstantProfessionalsQueryVariables>(FindInstantProfessionalsDocument, variables, options) as Promise<FindInstantProfessionalsQuery>
    },
    findSuggestedProfessionals(variables?: FindSuggestedProfessionalsQueryVariables, options?: C): Promise<FindSuggestedProfessionalsQuery> {
      return requester<FindSuggestedProfessionalsQuery, FindSuggestedProfessionalsQueryVariables>(FindSuggestedProfessionalsDocument, variables, options) as Promise<FindSuggestedProfessionalsQuery>
    },
    selectProfessionalForRequest(variables?: SelectProfessionalForRequestMutationVariables, options?: C): Promise<SelectProfessionalForRequestMutation> {
      return requester<SelectProfessionalForRequestMutation, SelectProfessionalForRequestMutationVariables>(SelectProfessionalForRequestDocument, variables, options) as Promise<SelectProfessionalForRequestMutation>
    },
    estimatedProfessionalAvailability(variables?: EstimatedProfessionalAvailabilityQueryVariables, options?: C): Promise<EstimatedProfessionalAvailabilityQuery> {
      return requester<EstimatedProfessionalAvailabilityQuery, EstimatedProfessionalAvailabilityQueryVariables>(EstimatedProfessionalAvailabilityDocument, variables, options) as Promise<EstimatedProfessionalAvailabilityQuery>
    },
    saveDraftBooking(variables?: SaveDraftBookingMutationVariables, options?: C): Promise<SaveDraftBookingMutation> {
      return requester<SaveDraftBookingMutation, SaveDraftBookingMutationVariables>(SaveDraftBookingDocument, variables, options) as Promise<SaveDraftBookingMutation>
    },
    publishBooking(variables?: PublishBookingMutationVariables, options?: C): Promise<PublishBookingMutation> {
      return requester<PublishBookingMutation, PublishBookingMutationVariables>(PublishBookingDocument, variables, options) as Promise<PublishBookingMutation>
    },
    addPromoCodeToUser(variables: AddPromoCodeToUserMutationVariables, options?: C): Promise<AddPromoCodeToUserMutation> {
      return requester<AddPromoCodeToUserMutation, AddPromoCodeToUserMutationVariables>(AddPromoCodeToUserDocument, variables, options) as Promise<AddPromoCodeToUserMutation>
    },
    userPromoCodes(variables?: UserPromoCodesQueryVariables, options?: C): Promise<UserPromoCodesQuery> {
      return requester<UserPromoCodesQuery, UserPromoCodesQueryVariables>(UserPromoCodesDocument, variables, options) as Promise<UserPromoCodesQuery>
    },
    getCrossSellPromoCode(variables: GetCrossSellPromoCodeMutationVariables, options?: C): Promise<GetCrossSellPromoCodeMutation> {
      return requester<GetCrossSellPromoCodeMutation, GetCrossSellPromoCodeMutationVariables>(GetCrossSellPromoCodeDocument, variables, options) as Promise<GetCrossSellPromoCodeMutation>
    },
    booking(variables?: BookingQueryVariables, options?: C): Promise<BookingQuery> {
      return requester<BookingQuery, BookingQueryVariables>(BookingDocument, variables, options) as Promise<BookingQuery>
    },
    bookings(variables?: BookingsQueryVariables, options?: C): Promise<BookingsQuery> {
      return requester<BookingsQuery, BookingsQueryVariables>(BookingsDocument, variables, options) as Promise<BookingsQuery>
    },
    requestBookingCancellation(variables?: RequestBookingCancellationMutationVariables, options?: C): Promise<RequestBookingCancellationMutation> {
      return requester<RequestBookingCancellationMutation, RequestBookingCancellationMutationVariables>(RequestBookingCancellationDocument, variables, options) as Promise<RequestBookingCancellationMutation>
    },
    cancelBooking(variables?: CancelBookingMutationVariables, options?: C): Promise<CancelBookingMutation> {
      return requester<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument, variables, options) as Promise<CancelBookingMutation>
    },
    createReview(variables?: CreateReviewMutationVariables, options?: C): Promise<CreateReviewMutation> {
      return requester<CreateReviewMutation, CreateReviewMutationVariables>(CreateReviewDocument, variables, options) as Promise<CreateReviewMutation>
    },
    updateReviewPrompted(variables?: UpdateReviewPromptedMutationVariables, options?: C): Promise<UpdateReviewPromptedMutation> {
      return requester<UpdateReviewPromptedMutation, UpdateReviewPromptedMutationVariables>(UpdateReviewPromptedDocument, variables, options) as Promise<UpdateReviewPromptedMutation>
    },
    getProfessional(variables?: GetProfessionalQueryVariables, options?: C): Promise<GetProfessionalQuery> {
      return requester<GetProfessionalQuery, GetProfessionalQueryVariables>(GetProfessionalDocument, variables, options) as Promise<GetProfessionalQuery>
    },
    searchProfessionals(variables?: SearchProfessionalsQueryVariables, options?: C): Promise<SearchProfessionalsQuery> {
      return requester<SearchProfessionalsQuery, SearchProfessionalsQueryVariables>(SearchProfessionalsDocument, variables, options) as Promise<SearchProfessionalsQuery>
    },
    reviews(variables?: ReviewsQueryVariables, options?: C): Promise<ReviewsQuery> {
      return requester<ReviewsQuery, ReviewsQueryVariables>(ReviewsDocument, variables, options) as Promise<ReviewsQuery>
    },
    favourites(variables?: FavouritesQueryVariables, options?: C): Promise<FavouritesQuery> {
      return requester<FavouritesQuery, FavouritesQueryVariables>(FavouritesDocument, variables, options) as Promise<FavouritesQuery>
    },
    addFavourite(variables?: AddFavouriteMutationVariables, options?: C): Promise<AddFavouriteMutation> {
      return requester<AddFavouriteMutation, AddFavouriteMutationVariables>(AddFavouriteDocument, variables, options) as Promise<AddFavouriteMutation>
    },
    removeFavourite(variables?: RemoveFavouriteMutationVariables, options?: C): Promise<RemoveFavouriteMutation> {
      return requester<RemoveFavouriteMutation, RemoveFavouriteMutationVariables>(RemoveFavouriteDocument, variables, options) as Promise<RemoveFavouriteMutation>
    },
    getAddresses(variables?: GetAddressesQueryVariables, options?: C): Promise<GetAddressesQuery> {
      return requester<GetAddressesQuery, GetAddressesQueryVariables>(GetAddressesDocument, variables, options) as Promise<GetAddressesQuery>
    },
    removeAddress(variables?: RemoveAddressMutationVariables, options?: C): Promise<RemoveAddressMutation> {
      return requester<RemoveAddressMutation, RemoveAddressMutationVariables>(RemoveAddressDocument, variables, options) as Promise<RemoveAddressMutation>
    },
    checkPostcodeInServiceArea(variables?: CheckPostcodeInServiceAreaQueryVariables, options?: C): Promise<CheckPostcodeInServiceAreaQuery> {
      return requester<CheckPostcodeInServiceAreaQuery, CheckPostcodeInServiceAreaQueryVariables>(CheckPostcodeInServiceAreaDocument, variables, options) as Promise<CheckPostcodeInServiceAreaQuery>
    },
    addOrUpdateAddress(variables?: AddOrUpdateAddressMutationVariables, options?: C): Promise<AddOrUpdateAddressMutation> {
      return requester<AddOrUpdateAddressMutation, AddOrUpdateAddressMutationVariables>(AddOrUpdateAddressDocument, variables, options) as Promise<AddOrUpdateAddressMutation>
    },
    getParkingInformation(variables?: GetParkingInformationQueryVariables, options?: C): Promise<GetParkingInformationQuery> {
      return requester<GetParkingInformationQuery, GetParkingInformationQueryVariables>(GetParkingInformationDocument, variables, options) as Promise<GetParkingInformationQuery>
    },
    addorUpdateParkingInformation(variables: AddorUpdateParkingInformationMutationVariables, options?: C): Promise<AddorUpdateParkingInformationMutation> {
      return requester<AddorUpdateParkingInformationMutation, AddorUpdateParkingInformationMutationVariables>(AddorUpdateParkingInformationDocument, variables, options) as Promise<AddorUpdateParkingInformationMutation>
    },
    answers(variables: AnswersMutationVariables, options?: C): Promise<AnswersMutation> {
      return requester<AnswersMutation, AnswersMutationVariables>(AnswersDocument, variables, options) as Promise<AnswersMutation>
    },
    balance(variables?: BalanceQueryVariables, options?: C): Promise<BalanceQuery> {
      return requester<BalanceQuery, BalanceQueryVariables>(BalanceDocument, variables, options) as Promise<BalanceQuery>
    },
    requestCardSetupIntent(variables?: RequestCardSetupIntentQueryVariables, options?: C): Promise<RequestCardSetupIntentQuery> {
      return requester<RequestCardSetupIntentQuery, RequestCardSetupIntentQueryVariables>(RequestCardSetupIntentDocument, variables, options) as Promise<RequestCardSetupIntentQuery>
    },
    cards(variables?: CardsQueryVariables, options?: C): Promise<CardsQuery> {
      return requester<CardsQuery, CardsQueryVariables>(CardsDocument, variables, options) as Promise<CardsQuery>
    },
    addCard(variables?: AddCardMutationVariables, options?: C): Promise<AddCardMutation> {
      return requester<AddCardMutation, AddCardMutationVariables>(AddCardDocument, variables, options) as Promise<AddCardMutation>
    },
    updateDefaultCard(variables?: UpdateDefaultCardMutationVariables, options?: C): Promise<UpdateDefaultCardMutation> {
      return requester<UpdateDefaultCardMutation, UpdateDefaultCardMutationVariables>(UpdateDefaultCardDocument, variables, options) as Promise<UpdateDefaultCardMutation>
    },
    removeCard(variables?: RemoveCardMutationVariables, options?: C): Promise<RemoveCardMutation> {
      return requester<RemoveCardMutation, RemoveCardMutationVariables>(RemoveCardDocument, variables, options) as Promise<RemoveCardMutation>
    },
    completePayment(variables: CompletePaymentMutationVariables, options?: C): Promise<CompletePaymentMutation> {
      return requester<CompletePaymentMutation, CompletePaymentMutationVariables>(CompletePaymentDocument, variables, options) as Promise<CompletePaymentMutation>
    },
    createGiftCard(variables?: CreateGiftCardMutationVariables, options?: C): Promise<CreateGiftCardMutation> {
      return requester<CreateGiftCardMutation, CreateGiftCardMutationVariables>(CreateGiftCardDocument, variables, options) as Promise<CreateGiftCardMutation>
    },
    validateGiftCard(variables?: ValidateGiftCardMutationVariables, options?: C): Promise<ValidateGiftCardMutation> {
      return requester<ValidateGiftCardMutation, ValidateGiftCardMutationVariables>(ValidateGiftCardDocument, variables, options) as Promise<ValidateGiftCardMutation>
    },
    redeemGiftCard(variables?: RedeemGiftCardMutationVariables, options?: C): Promise<RedeemGiftCardMutation> {
      return requester<RedeemGiftCardMutation, RedeemGiftCardMutationVariables>(RedeemGiftCardDocument, variables, options) as Promise<RedeemGiftCardMutation>
    },
    tipProfessional(variables?: TipProfessionalMutationVariables, options?: C): Promise<TipProfessionalMutation> {
      return requester<TipProfessionalMutation, TipProfessionalMutationVariables>(TipProfessionalDocument, variables, options) as Promise<TipProfessionalMutation>
    },
    loyaltyPoints(variables?: LoyaltyPointsQueryVariables, options?: C): Promise<LoyaltyPointsQuery> {
      return requester<LoyaltyPointsQuery, LoyaltyPointsQueryVariables>(LoyaltyPointsDocument, variables, options) as Promise<LoyaltyPointsQuery>
    },
    redeemReward(variables: RedeemRewardMutationVariables, options?: C): Promise<RedeemRewardMutation> {
      return requester<RedeemRewardMutation, RedeemRewardMutationVariables>(RedeemRewardDocument, variables, options) as Promise<RedeemRewardMutation>
    },
    calculateLoyaltyPoints(variables?: CalculateLoyaltyPointsQueryVariables, options?: C): Promise<CalculateLoyaltyPointsQuery> {
      return requester<CalculateLoyaltyPointsQuery, CalculateLoyaltyPointsQueryVariables>(CalculateLoyaltyPointsDocument, variables, options) as Promise<CalculateLoyaltyPointsQuery>
    },
    isApiUp(variables?: IsApiUpQueryVariables, options?: C): Promise<IsApiUpQuery> {
      return requester<IsApiUpQuery, IsApiUpQueryVariables>(IsApiUpDocument, variables, options) as Promise<IsApiUpQuery>
    },
    settings(variables?: SettingsQueryVariables, options?: C): Promise<SettingsQuery> {
      return requester<SettingsQuery, SettingsQueryVariables>(SettingsDocument, variables, options) as Promise<SettingsQuery>
    },
    appVer(variables?: AppVerQueryVariables, options?: C): Promise<AppVerQuery> {
      return requester<AppVerQuery, AppVerQueryVariables>(AppVerDocument, variables, options) as Promise<AppVerQuery>
    },
    chats(variables?: ChatsQueryVariables, options?: C): Promise<ChatsQuery> {
      return requester<ChatsQuery, ChatsQueryVariables>(ChatsDocument, variables, options) as Promise<ChatsQuery>
    },
    markChatAsRead(variables: MarkChatAsReadMutationVariables, options?: C): Promise<MarkChatAsReadMutation> {
      return requester<MarkChatAsReadMutation, MarkChatAsReadMutationVariables>(MarkChatAsReadDocument, variables, options) as Promise<MarkChatAsReadMutation>
    },
    findOrCreateChat(variables: FindOrCreateChatMutationVariables, options?: C): Promise<FindOrCreateChatMutation> {
      return requester<FindOrCreateChatMutation, FindOrCreateChatMutationVariables>(FindOrCreateChatDocument, variables, options) as Promise<FindOrCreateChatMutation>
    },
    getUnreadMessages(variables?: GetUnreadMessagesQueryVariables, options?: C): Promise<GetUnreadMessagesQuery> {
      return requester<GetUnreadMessagesQuery, GetUnreadMessagesQueryVariables>(GetUnreadMessagesDocument, variables, options) as Promise<GetUnreadMessagesQuery>
    },
    checkBlockedUser(variables?: CheckBlockedUserQueryVariables, options?: C): Promise<CheckBlockedUserQuery> {
      return requester<CheckBlockedUserQuery, CheckBlockedUserQueryVariables>(CheckBlockedUserDocument, variables, options) as Promise<CheckBlockedUserQuery>
    },
    getConfig(variables?: GetConfigQueryVariables, options?: C): Promise<GetConfigQuery> {
      return requester<GetConfigQuery, GetConfigQueryVariables>(GetConfigDocument, variables, options) as Promise<GetConfigQuery>
    },
    page(variables?: PageQueryVariables, options?: C): Promise<PageQuery> {
      return requester<PageQuery, PageQueryVariables>(PageDocument, variables, options) as Promise<PageQuery>
    },
    createOrUpdateDevice(variables?: CreateOrUpdateDeviceMutationVariables, options?: C): Promise<CreateOrUpdateDeviceMutation> {
      return requester<CreateOrUpdateDeviceMutation, CreateOrUpdateDeviceMutationVariables>(CreateOrUpdateDeviceDocument, variables, options) as Promise<CreateOrUpdateDeviceMutation>
    },
    uploadFile(variables: UploadFileMutationVariables, options?: C): Promise<UploadFileMutation> {
      return requester<UploadFileMutation, UploadFileMutationVariables>(UploadFileDocument, variables, options) as Promise<UploadFileMutation>
    },
    deleteFile(variables?: DeleteFileMutationVariables, options?: C): Promise<DeleteFileMutation> {
      return requester<DeleteFileMutation, DeleteFileMutationVariables>(DeleteFileDocument, variables, options) as Promise<DeleteFileMutation>
    },
    triggerUserEvent(variables: TriggerUserEventQueryVariables, options?: C): Promise<TriggerUserEventQuery> {
      return requester<TriggerUserEventQuery, TriggerUserEventQueryVariables>(TriggerUserEventDocument, variables, options) as Promise<TriggerUserEventQuery>
    },
    checkProfessionalAvailability(variables: CheckProfessionalAvailabilityQueryVariables, options?: C): Promise<CheckProfessionalAvailabilityQuery> {
      return requester<CheckProfessionalAvailabilityQuery, CheckProfessionalAvailabilityQueryVariables>(CheckProfessionalAvailabilityDocument, variables, options) as Promise<CheckProfessionalAvailabilityQuery>
    },
    manageSubscriptionUrl(variables?: ManageSubscriptionUrlQueryVariables, options?: C): Promise<ManageSubscriptionUrlQuery> {
      return requester<ManageSubscriptionUrlQuery, ManageSubscriptionUrlQueryVariables>(ManageSubscriptionUrlDocument, variables, options) as Promise<ManageSubscriptionUrlQuery>
    },
    checkoutUrl(variables: CheckoutUrlQueryVariables, options?: C): Promise<CheckoutUrlQuery> {
      return requester<CheckoutUrlQuery, CheckoutUrlQueryVariables>(CheckoutUrlDocument, variables, options) as Promise<CheckoutUrlQuery>
    },
    deleteUser(variables?: DeleteUserMutationVariables, options?: C): Promise<DeleteUserMutation> {
      return requester<DeleteUserMutation, DeleteUserMutationVariables>(DeleteUserDocument, variables, options) as Promise<DeleteUserMutation>
    },
    inAppMessages(variables: InAppMessagesQueryVariables, options?: C): Promise<InAppMessagesQuery> {
      return requester<InAppMessagesQuery, InAppMessagesQueryVariables>(InAppMessagesDocument, variables, options) as Promise<InAppMessagesQuery>
    },
    inAppMessage(variables: InAppMessageQueryVariables, options?: C): Promise<InAppMessageQuery> {
      return requester<InAppMessageQuery, InAppMessageQueryVariables>(InAppMessageDocument, variables, options) as Promise<InAppMessageQuery>
    },
    prepareForPayment(variables: PrepareForPaymentQueryVariables, options?: C): Promise<PrepareForPaymentQuery> {
      return requester<PrepareForPaymentQuery, PrepareForPaymentQueryVariables>(PrepareForPaymentDocument, variables, options) as Promise<PrepareForPaymentQuery>
    },
  }
}
export type Sdk = ReturnType<typeof getSdk>;